import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  IRichLogData,
  IRichLogRecord,
  LOGS_COLUMN_KEY,
  TInfoItem,
  translateInfoItemDecoded,
} from "@ryde/shared";

import { IExportLogsCsvData } from "../rich-logs.models";
import { useGenerateLogHtml } from "./use-generate-log-html";

interface IUseRichLogsExportCsvDataParams {
  records?: IRichLogRecord[];
  logsFromWatchedApiOld?: TInfoItem[];
  idOnlyLinks?: boolean;
}

export const useRichLogsExportCsvData = ({
  records,
  logsFromWatchedApiOld,
  idOnlyLinks,
}: IUseRichLogsExportCsvDataParams): IExportLogsCsvData[] => {
  const { t } = useTranslation();
  const { generateTextForCsvExportDecoded } = useGenerateLogHtml({
    idOnlyLinks,
  });

  return useMemo(() => {
    if (records?.length) {
      return records.map(logRecord => ({
        [LOGS_COLUMN_KEY]: generateTextForCsvExportDecoded(logRecord),
      }));
    }

    if (logsFromWatchedApiOld?.length) {
      return logsFromWatchedApiOld.map(log => ({
        [LOGS_COLUMN_KEY]: translateInfoItemDecoded(log, t),
      }));
    }

    return [];
  }, [generateTextForCsvExportDecoded, logsFromWatchedApiOld, records, t]);
};

export const resolveRichLogsDataForExport = ({
  logsFormWatched,
  isFinished,
  logDataFromAtom,
}: {
  logsFormWatched?: IRichLogData;
  isFinished?: boolean;
  logDataFromAtom?: IRichLogData;
}): IRichLogData => {
  return (
    logsFormWatched ??
    (isFinished && logDataFromAtom ? logDataFromAtom : { records: [] })
  );
};
